import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainFR() {
  const articleData = {
    title: "Pourquoi certaines personnes nous épuisent-elles ? (L'IA l'explique)",
    description: "Vous vous sentez émotionnellement épuisé par les SMS ? Découvrez comment l'IA de Toxic Detector détecte la communication unilatérale et les schémas subtils d'épuisement émotionnel dans vos relations.",
    slug: 'emotional-drain-relationships-ai',
    publishDate: '2025-09-03',
    author: 'Rédaction Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: "Qu'est-ce que l'épuisement émotionnel dans les relations ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "L'épuisement émotionnel survient lorsque les interactions avec quelqu'un vous laissent constamment fatigué, frustré ou coupable, souvent en raison d'une communication unilatérale ou manipulatrice."
      }
    }, {
      '@type': 'Question',
      name: 'Comment les SMS peuvent-ils causer un épuisement émotionnel ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Des messages unilatéraux répétés, la culpabilisation, un engagement incohérent ou une critique subtile peuvent vous laisser épuisé, même sans conflit majeur.'
      }
    }, {
      '@type': 'Question',
      name: "L'IA peut-elle détecter qui draine mon énergie émotionnelle ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Oui. Toxic Detector analyse les schémas de texte, le ton et l'engagement pour mettre en évidence instantanément les comportements unilatéraux, manipulateurs ou épuisants."
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/fr/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Lien copié dans le presse-papiers !');
    }
  };
  return <>
      <MetaTags title="Pourquoi certaines personnes nous épuisent-elles ? — IA explique l'épuisement émotionnel | ToxicDetector" description="Vous vous sentez émotionnellement épuisé par les SMS ? Découvrez comment l'IA de Toxic Detector détecte la communication unilatérale et les schémas subtils d'épuisement émotionnel." keywords="épuisement émotionnel dans les relations, schémas de texte unilatéraux, vampires énergétiques, analyse émotionnelle IA" canonical={`https://toxicdetector.com/fr/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/dA7JvMmr79gFQy3nZ9PyWw/file_00000000ee5472468a16f1060b3742e2.png" schema={[faqSchema, articleSchema]} data-id="element-5470" data-mp="22qjrgr6ijm5q" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-5471" data-mp="34bayh7a97dgs">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-5472" data-mp="3iaanig1ohudh">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-5473" data-mp="3e6l0vw4kdmv3">
            <div className="flex items-center justify-between" data-id="element-5474" data-mp="xj0eieikorng">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-5475" data-mp="xhfkcq067aq4">
                <span className="text-2xl" data-id="element-5476" data-mp="ti6tpu0ffsys">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-5477" data-mp="tjrl5arg2vsf">
                  ToxicDetector
                </span>
              </Link>
              <div className="flex items-center gap-3" data-id="element-5478" data-mp="1stgo6bkzj2xo">
                <Link to="/signup" className="hidden sm:inline-block bg-red-600 text-white px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-red-700 transition-all shadow-sm hover:shadow-md" data-id="element-5479" data-mp="1xs0cgin1wqt7">
                  Scan Gratuit
                </Link>
                <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Partager l'article" data-id="element-5480" data-mp="2bqzqyxgunpbn">
                  <Share2 size={20} className="text-gray-600" data-id="element-5481" data-mp="2lgjdcd3ru1b9" />
                </button>
              </div>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-5482" data-mp="2vfsbzj9l043y">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-5483" data-mp="2vdxru764wg0x">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-5484" data-mp="essqwco2lpyp" />
            Retour à l'Accueil
          </Link>

          <header className="mb-16" data-id="element-5485" data-mp="4whc9g10co13">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-5486" data-mp="4xinpllxrcjc">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-5487" data-mp="xl4q4qjfgb4m">
              <time dateTime={articleData.publishDate} data-id="element-5488" data-mp="st3f17xzwqg6">
                {new Date(articleData.publishDate).toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-5489" data-mp="1lbii6h20i9z7">•</span>
              <span data-id="element-5490" data-mp="1gi5ymlc6wtdb">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-16" data-id="element-5491" data-mp="3aqjlb82fnfrl">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ajgMhQjEKnfJfWgPd5sqFq/1763122862210.jpg" alt="IA analysant les schémas d'épuisement émotionnel dans les SMS" className="w-full rounded-2xl shadow-lg" data-id="element-5492" data-mp="3arl4y0xilakx" />
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200 mb-16" data-id="element-5493" data-mp="35yi73glpfeyx">
            <h2 className="font-bold text-xl mb-6 text-gray-900" data-id="element-5494" data-mp="2rzin4m94zo93">
              Table des Matières
            </h2>
            <ol className="space-y-3.5 text-base list-decimal list-inside" data-id="element-5495" data-mp="2w38871qlrnpd">
              <li data-id="element-5496" data-mp="2i35qpgm7iwan">
                <a href="#always-something-wrong" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-5497" data-mp="2i3yrm0yhirkv">
                  L'ami "Il y a toujours quelque chose qui ne va pas"
                </a>
              </li>
              <li data-id="element-5498" data-mp="l8j1vew1nk00">
                <a href="#only-when-they-need" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-5499" data-mp="l92ld01cegg5">
                  La personne qui n'écrit que quand elle a besoin de quelque
                  chose
                </a>
              </li>
              <li data-id="element-5500" data-mp="2fjiyu90kb007">
                <a href="#dry-texting" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-5501" data-mp="2ar9agxf3i801">
                  Le "Dry-Texter" sans émotion
                </a>
              </li>
              <li data-id="element-5502" data-mp="2jj1hey4wuyzv">
                <a href="#ghost-return" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-5503" data-mp="2jlnnsug2f8gi">
                  L'artiste du Ghosting & Retour
                </a>
              </li>
              <li data-id="element-5504" data-mp="143kl3rufvpsn">
                <a href="#guilt-tripper" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-5505" data-mp="1432lqmchcvgi">
                  Le culpabilisateur subtil
                </a>
              </li>
              <li data-id="element-5506" data-mp="i8tyr6n8xclb">
                <a href="#faux-supporter" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-5507" data-mp="i8bupnucdu2u">
                  Le faux supporter
                </a>
              </li>
              <li data-id="element-5508" data-mp="s19k8dxr4jay">
                <a href="#healthy-toxic-combo" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-5509" data-mp="3qh2b6p3meifd">
                  Le combo "Sain-Toxique"
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-5510" data-mp="4bylf1zyoyzg">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-5511" data-mp="8bz10pysrg83">
              Avez-vous déjà envoyé un SMS à quelqu'un et vous êtes-vous senti
              fatigué, agacé ou étrangement coupable après, même si la
              conversation n'était pas une dispute ? C'est{' '}
              <strong className="text-gray-900" data-id="element-5512" data-mp="3473ptr9tx0le">
                l'épuisement émotionnel dans les relations
              </strong>
              , et c'est plus courant que vous ne le pensez.
            </p>
            <p className="mb-16 text-lg leading-relaxed text-gray-600" data-id="element-5513" data-mp="2veikpdz4esf1">
              Ce sont des{' '}
              <strong className="text-gray-900" data-id="element-5514" data-mp="2qggy4j2hkayt">
                schémas de texte unilatéraux
              </strong>{' '}
              et une manipulation subtile. Notre{' '}
              <strong className="text-gray-900" data-id="element-5515" data-mp="2ghreoluxyigg">analyse IA</strong> lit ces
              schémas instantanément.
            </p>

            <section id="always-something-wrong" className="mb-16" data-id="element-5516" data-mp="2chhbfgyja65a">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5517" data-mp="27j61l688nvn2">
                1️⃣ L'ami "Il y a toujours quelque chose qui ne va pas"
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5518" data-mp="5q84uzbcciwu">
                Vous regardez votre téléphone et ressentez instantanément :
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-5519" data-mp="9jmcydohxuxq">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-5520" data-mp="4ksyoj1dxzwi">
                  "Oh mon Dieu... quoi maintenant ?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5521" data-mp="dkfxqy6n6tme">
                Chaque message est du stress, du chaos ou des plaintes. L'IA
                marque cela comme une{' '}
                <strong className="text-gray-900" data-id="element-5522" data-mp="3hye8nwc0f5jv">
                  charge émotionnelle unilatérale
                </strong>
                .
              </p>
            </section>

            <section id="only-when-they-need" className="mb-16" data-id="element-5523" data-mp="3qxrhqnw81s42">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5524" data-mp="3qw6pj4xdql9d">
                2️⃣ La personne qui n'écrit que quand elle a besoin de quelque
                chose
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-5525" data-mp="2y7rjv9051fap">
                <p className="mb-4 text-lg text-gray-700" data-id="element-5526" data-mp="1dpgpsld3u4u8">
                  <strong className="text-gray-900" data-id="element-5527" data-mp="1ijbigeaotu5g">Jamais :</strong> "Comment
                  vas-tu ?"
                </p>
                <p className="text-lg text-gray-700" data-id="element-5528" data-mp="14sg44mhf6kuh">
                  <strong className="text-gray-900" data-id="element-5529" data-mp="19pgeh9lay9re">Toujours :</strong>{' '}
                  "Peux-tu... ?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5530" data-mp="1xgbznnv966po">
                L'IA détecte cela comme une{' '}
                <strong className="text-gray-900" data-id="element-5531" data-mp="21etaahdvtzbu">
                  communication transactionnelle
                </strong>
                .
              </p>
            </section>

            <section id="dry-texting" className="mb-16" data-id="element-5532" data-mp="1sempeafutx2n">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5533" data-mp="c1y4jvfwn1lt">
                3️⃣ Le "Dry-Texter" sans émotion
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-5534" data-mp="gz7s15jqh370">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-5535" data-mp="3t3spcx3iwj8t">
                  "ok."
                  <br data-id="element-5536" data-mp="3p3s5gwxnnfud" />
                  "K."
                  <br data-id="element-5537" data-mp="3kbqlspy5qmub" />
                  "👍"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-5538" data-mp="3fdfdijnigke7">
                L'IA capte ces{' '}
                <strong className="text-gray-900" data-id="element-5539" data-mp="3aelzmq4bardi">
                  signaux de déconnexion
                </strong>{' '}
                instantanément.
              </p>
            </section>

            <section id="ghost-return" className="mb-16" data-id="element-5540" data-mp="31d4kb9yqatpv">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5541" data-mp="31do4yyfrjw7l">
                4️⃣ L'artiste du Ghosting & Retour
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5542" data-mp="zmb18cpj7ud4">
                Disparaît pendant 3 semaines. Revient comme :
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-5543" data-mp="ukvdudzvtbrk">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-5544" data-mp="1267gr18r1lq3">
                  "saluuut 😁"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5545" data-mp="1bvqy22gtd7iu">
                L'IA marque cela comme un{' '}
                <strong className="text-gray-900" data-id="element-5546" data-mp="1gvn5kbopzh35">engagement incohérent</strong>
                .
              </p>
            </section>

            <section id="guilt-tripper" className="mb-16" data-id="element-5547" data-mp="j9fx2qpap4li">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5548" data-mp="o5wopuvpe13c">
                5️⃣ Le culpabilisateur subtil
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-5549" data-mp="t7vnergi09ty">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-5550" data-mp="x59x0k83cjmh">
                  "Je suppose que j'irai seul alors..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-5551" data-mp="28lhzymrfpwyo">
                L'IA marque cela comme une{' '}
                <strong className="text-gray-900" data-id="element-5552" data-mp="275mg9p75euiy">manipulation passive</strong>.
              </p>
            </section>

            <section id="faux-supporter" className="mb-16" data-id="element-5553" data-mp="228nm56nhinkr">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5554" data-mp="2h4blahdy4khs">
                6️⃣ Le faux supporter
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-5555" data-mp="2c6tmvkxk1no1">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-5556" data-mp="2q25kc033hs8n">
                  "Je veux dire, tu as tendance à réagir de manière excessive
                  parfois."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5557" data-mp="2uuyk09jpiadv">
                L'IA détecte la{' '}
                <strong className="text-gray-900" data-id="element-5558" data-mp="38uge94frufum">critique masquée</strong>.
              </p>
            </section>

            <section id="healthy-toxic-combo" className="mb-16" data-id="element-5559" data-mp="34txkv5y8d1qb">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5560" data-mp="34rbeh9n2ss9o">
                7️⃣ Le combo "Sain-Toxique"
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-5561" data-mp="3sfgodj8577ka">
                <p className="mb-4 text-lg text-gray-700" data-id="element-5562" data-mp="3ehjoodye6l1e">
                  Certains jours chauds. Certains jours froids.
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-5563" data-mp="3jho7iamrvrus">
                L'IA étiquette ce schéma comme un{' '}
                <strong className="text-gray-900" data-id="element-5564" data-mp="39i74y22thu31">
                  rythme émotionnel instable
                </strong>
                .
              </p>
            </section>

            <section className="mb-16" data-id="element-5565" data-mp="2zru9hetgsgi4">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5566" data-mp="2zsvvgec0qnem">
                Pourquoi cela compte
              </h2>
              <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-10 mb-10 border border-red-100" data-id="element-5567" data-mp="2lu5wet5n2dnm">
                <p className="font-bold mb-8 text-2xl text-gray-900" data-id="element-5568" data-mp="wapae9wrrjyo">
                  Une fois que vous voyez le schéma, vous pouvez :
                </p>
                <ul className="space-y-5" data-id="element-5569" data-mp="rinzarbc7za8">
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-5570" data-mp="nidx7pqo1t0n">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-5571" data-mp="ng9iecr8b9ll">
                      ✓
                    </span>
                    <span data-id="element-5572" data-mp="1fa39f69cvkw1">Protéger votre énergie</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-5573" data-mp="1b886jxbs0zg5">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-5574" data-mp="1b6dmel8bxbd4">
                      ✓
                    </span>
                    <span data-id="element-5575" data-mp="11ak2ggsa6flb">Fixer des limites</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-5576" data-mp="3qzclkc1543kx">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-5577" data-mp="3qx9kmwyg8q1f">
                      ✓
                    </span>
                    <span data-id="element-5578" data-mp="3bwktx2dt21w9">Arrêter de vous sentir coupable</span>
                  </li>
                </ul>
              </div>
            </section>

            <section id="faq" className="mb-20" data-id="element-5579" data-mp="3gvxgdm0rl6yb">
              <h2 className="text-4xl font-bold mb-10 tracking-tight text-gray-900" data-id="element-5580" data-mp="3lusahk46mhxq">
                Questions Fréquentes
              </h2>
              <div className="space-y-5" data-id="element-5581" data-mp="3qm0iqctrzx9b">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-5582" data-mp="3umap3qlhcpop" data-mpi={index}>
                    <h3 className="font-bold text-xl mb-4 text-gray-900" data-id="element-5583" data-mp="8g5ej7b075dv">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-lg" data-id="element-5584" data-mp="dcckv17baiwc">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl" data-id="element-5585" data-mp="kx6gzxvw4w8p">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-5586" data-mp="fy3mh7dje8ez">
              😮‍💨 Arrêtez de vous sentir épuisé.
              <br data-id="element-5587" data-mp="uq46inzavlgt" />
              Commencez à voir clairement.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-5588" data-mp="ppgb7q41gigs">
              Arrêtez de deviner. Téléchargez vos textes sur Toxic Detector et
              obtenez un score de toxicité instantané.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-10 border border-white/20" data-id="element-5589" data-mp="b020oeoq7uzt">
              <p className="font-bold text-2xl" data-id="element-5590" data-mp="6yox6b93w3w2">
                "⚠️ Épuisement Émotionnel : Élevé. Communication unilatérale
                détectée."
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-5591" data-mp="1idm0mq61evmy">
              Scannez vos chats maintenant →
            </Link>
          </div>

          <div className="mt-20" data-id="element-5592" data-mp="1fz720rrxfqbw">
            <RelatedBlogPosts posts={[{
            title: 'Pourquoi certaines personnes nous épuisent-elles ? Partie 2',
            description: 'Plus de schémas subtils qui drainent votre énergie, y compris la surexplication et les je-sais-tout.',
            slug: 'emotional-drain-part-2',
            emoji: '😭'
          }, {
            title: 'Le Guide Ultime des Textes Passifs-Agressifs',
            description: 'Repérez le comportement passif-agressif et la manipulation cachée dans les SMS.',
            slug: 'ultimate-guide-passive-aggressive-texts',
            emoji: '😤'
          }]} data-id="element-5593" data-mp="1g08ortib219g" />
          </div>

          <div className="mt-16 text-center" data-id="element-5594" data-mp="rtoyz62xho8o">
            <button onClick={handleShare} className="inline-flex items-center gap-2 text-gray-700 hover:text-red-600 font-semibold transition-colors px-6 py-3 rounded-lg hover:bg-gray-50" data-id="element-5595" data-mp="wsi2c5oi3yv4">
              <Share2 size={20} data-id="element-5596" data-mp="n0vv0kfaajxn" />
              Partager cet article
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-5597" data-mp="94if3fqeeqla">
          <div className="max-w-4xl mx-auto px-6" data-id="element-5598" data-mp="d5294afode37">
            <div className="border-t border-gray-800 pt-8 text-center" data-id="element-5599" data-mp="d1obffhyht23">
              <p className="text-gray-400 text-sm" data-id="element-5600" data-mp="3vbgo8cpoju36">
                © {new Date().getFullYear()} ToxicDetector. Tous droits
                réservés.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>;
}